import { useQueryParams } from '../../../hooks/useQueryParams'

interface LedgerEntriesFilters {
  ledgerSearchQuery?: string
}

type UseLedgerEntriesFiltersResponse = [LedgerEntriesFilters, (filters: Partial<LedgerEntriesFilters>) => void]

const defaultQuery: LedgerEntriesFilters = { ledgerSearchQuery: undefined }

export const useLedgerEntriesFilters = (): UseLedgerEntriesFiltersResponse =>
  useQueryParams<LedgerEntriesFilters>({ defaultQuery })
